module.exports = __webpack_public_path__ + "img/arrow-left.31d8fc3c.svg";